"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionConsumeSubject = exports.orderConsumeSubject = exports.dispatchOrderChangedEvent = exports.ActiveOrderTPSLStore = exports.dispatchPositionTpSlEvent = exports.PositionTPSLStore = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TriggersApi_1 = require("../../../apis/TriggersApi");
const multiFactory_1 = require("./multiFactory");
const TriggersApi_2 = require("../../../apis/TriggersApi");
const factory_1 = require("./factory");
/**查询与仓位关联的条件单（包含止盈止损已经追踪出场） */
function queryPositionTriggers(positionIds) {
    return (0, TriggersApi_1.queryTriggersWithPositions)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        positionIds,
    });
}
/**获取用来订阅数据更新的subject，以及发送数据更新通知的notifyDataChanged函数 */
const { notifyDataChanged: positionNotifyDataChanged, consumeSubject: positionConsumeSubject } = (0, multiFactory_1.multiConsumeSubjectFactory)();
exports.positionConsumeSubject = positionConsumeSubject;
/**生成管理仓位绑定的条件单的实例 */
exports.PositionTPSLStore = (0, multiFactory_1.positionTriggersProviderFactory)({
    query: queryPositionTriggers,
    notifyDataChanged: positionNotifyDataChanged,
    dataKey: "trigger_position_id",
});
/**
 * - 当前持仓发生变更时，调用该函数刷新仓位关联的止盈止损条件单
 * - 当仓位关联的止盈止损发生改变时，也可以调用该函数通知PositionTPSLStore更新数据
 */
exports.dispatchPositionTpSlEvent = (0, multiFactory_1.multiDispatchEventFactory)(exports.PositionTPSLStore);
function queryList(ids) {
    return (0, TriggersApi_2.queryTriggersWithOrderId)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        order_ids: ids,
    });
}
// 创建consumeSubject以及notifyDataChanged函数
// 当调用notifyDataChanged函数之后，会触发事件并通知consumeSubject的所有订阅者，最终将更新UI上的状态
const { notifyDataChanged: orderNotifyDataChanged, consumeSubject: orderConsumeSubject } = (0, factory_1.consumeSubjectFactory)();
exports.orderConsumeSubject = orderConsumeSubject;
// 生成管理订单的止盈止损的实例
exports.ActiveOrderTPSLStore = (0, factory_1.tpSlProviderFactory)({
    query: queryList,
    notifyDataChanged: orderNotifyDataChanged,
    dataKey: "trigger_order_id",
});
// 生成dispatchOrderChangedEvent函数，用来通知ActiveOrderTPSLStore更新数据
exports.dispatchOrderChangedEvent = (0, factory_1.dispatchEventFactory)(exports.ActiveOrderTPSLStore);
